import { render, staticRenderFns } from "./activityStatusesTable.vue?vue&type=template&id=8ec2404a"
import script from "./activityStatusesTable.vue?vue&type=script&lang=js"
export * from "./activityStatusesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports